import Navbar from 'components/navbar';
import { PrinterIcon } from 'lucide-react';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Skeleton } from 'primereact/skeleton';
import RoomHeader from 'screens/CalculationsScreen/utils/RoomHeader';
import { commaSeparatedNumbers } from '../../utils/commaSeparatedNumbers';
import classes from './detailedSchedule.module.scss';
import { useDefaultDetailedSchedule } from './useDefaultDetailedSchedule.logic';

const DetailedSchedule = () => {
  const { detailedSchedule, isLoading, expandedRooms, toggleRoom, handlePrint } =
    useDefaultDetailedSchedule();

  return (
    <div className={classes.detailedScheduleContainer}>
      <Navbar heading="Detailed Schedule" />
      <div className={classes.detailedScheduleHeader}>
        <div className={classes.detailedScheduleHeaderDate}></div>
        <div className={classes.detailedScheduleHeaderButtons}>
          <Button
            id="print-btn"
            icon={<PrinterIcon color="#4D2E6D" />}
            rounded
            style={{ backgroundColor: '#D6B1FD', border: 'none' }}
            disabled={isLoading}
            onClick={handlePrint}
          />
        </div>
      </div>
      {isLoading ? (
        <Skeleton height="80vh" width="100%" />
      ) : (
        <>
          <div className={classes.detailedScheduleContent}>
            {detailedSchedule &&
              detailedSchedule.map(item => (
                <div key={item.room_id} className={classes.detailedScheduleContentSection}>
                  <RoomHeader
                    name={item.name}
                    isExpanded={expandedRooms[item.room_id]}
                    onToggle={() => toggleRoom(item.room_id)}
                  />
                  {expandedRooms[item.room_id] && (
                    <DataTable
                      value={item.data}
                      emptyMessage="No records found"
                      className={classes.dataTable}
                      resizableColumns
                      columnResizeMode="expand"
                      scrollable
                      scrollHeight="flex"
                      rowClassName={rowData =>
                        `${classes.tableRow} ${!rowData.ndc ? classes.cleanRow : ''}`
                      }
                    >
                      <Column field="job_id" header="Job/Clean" className={classes.column} />
                      <Column field="priority" header="Priority" className={classes.column} />
                      <Column field="ndc" header="NDC" className={classes.column} />

                      <Column
                        field="schedule_status"
                        header="Status"
                        className={classes.column}
                        body={rowData => rowData.schedule_status}
                      />
                      <Column
                        field="product_name"
                        header="Product Name"
                        className={classes.column}
                      />

                      <Column
                        field="qty_to_make"
                        header="Qty to Make"
                        className={classes.column}
                        body={rowData => commaSeparatedNumbers(rowData.qty_to_make)}
                      />
                      <Column
                        field="bottle_qty"
                        header="Bottle Qty"
                        className={classes.column}
                        body={rowData => commaSeparatedNumbers(rowData.bottle_qty)}
                      />
                      <Column field="run_type" header="Run Type" className={classes.column} />
                      <Column field="start_time" header="Start Time" className={classes.column} />
                      <Column field="duration" header="Duration" className={classes.column} />
                      <Column
                        field="bulk_qty"
                        header="Bulk Quantity"
                        className={classes.column}
                        body={rowData => commaSeparatedNumbers(rowData.bulk_qty)}
                      />
                      <Column
                        field="confirmed_date"
                        header="Days since confirmed"
                        className={classes.column}
                      />
                    </DataTable>
                  )}
                </div>
              ))}
          </div>
        </>
      )}
    </div>
  );
};

export default observer(DetailedSchedule);
